import { Component, AfterViewInit, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { StorageService } from "../../services/storage/storage.service";

@Component({
  selector: 'gln-popin',
  templateUrl: './gln-popin.component.html'
})
export class GlnPopinComponent implements AfterViewInit {
  dialogRef?: MatDialogRef<any>;

  @ViewChild('glnDialog') glnDialog!: TemplateRef<any>;

  constructor(
    private _storage: StorageService,
    private _router: Router,
    private _dialog: MatDialog
  ) {}

  ngAfterViewInit(): void {
    this.openDialog();
  }

  openDialog() {
    try {
      const config: MatDialogConfig = new MatDialogConfig();
      config.maxWidth = '850px';
      config.disableClose = true;
      config.closeOnNavigation = false;

      this.dialogRef = this._dialog.open(this.glnDialog, config);
    } catch (err) {
      console.error(err);
    }
  }

  closeDialog() {
    this.dialogRef?.close();
    this._router.navigateByUrl('/mes-gln');
  }

  goToMesGLN() {
    this.dialogRef?.close();
    this._router.navigateByUrl('/mes-gln');
  }
}
